import { createContext } from 'react'

/**
 * Context that signals when `StepWrapper` is rendered inside an outer
 * "embedded" host (currently the PF revamp `StepShell`).
 *
 * When `embedded` is `true`, `StepWrapper` strips redundant chrome:
 * - hides its own H1 + subtitle (the embedding host owns the page header)
 * - drops the outer horizontal padding (the embedding host already pads)
 *
 * Default value (`embedded: false`) means the wrapper renders verbatim
 * legacy chrome, so untouched legacy `/purchase-flow` routes are unaffected.
 *
 * Phase E-B.1 / E-B.2 — Instructions step audit (2026-05-04).
 */
export interface StepWrapperEmbeddedContextValue {
  /** Hide the H1 + subtitle block when `true`. */
  hideTitle: boolean
  /** Drop the horizontal page padding when `true`. */
  noPadding: boolean
}

export const StepWrapperEmbeddedContext = createContext<StepWrapperEmbeddedContextValue>({
  hideTitle: false,
  noPadding: false,
})
